import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import ModalWithoutWrapper from 'components/new_ui/Modal/ModalWithoutWrapper';
import VideoPlayer from 'components/Widgets/VideoPlayer';
import ExternalLink from 'components/Widgets/ExternalLink';

export default function CardButton({ resource }) {
  const [showPlayer, setShowPlayer] = useState(false);

  if (resource.attributes.type_resource === 'file') {
    return (
      <ExternalLink href={resource.attributes.file_url}>
        Download
      </ExternalLink>
    );
  }

  if (resource.attributes.type_resource === 'url') {
    return (
      <ExternalLink href={resource.attributes.url}>
        Open
      </ExternalLink>
    );
  }

  if (resource.attributes.type_resource === 'vimeo') {
    return (
      <>
        <Button
          onClick={() => setShowPlayer(true)}
        >
          View
        </Button>

        <ModalWithoutWrapper size="lg" show={showPlayer} onHide={() => setShowPlayer(false)}>
          <VideoPlayer
            url={resource.attributes.vimeo}
            style={{ width: '100%', height: '100%' }}
          />
        </ModalWithoutWrapper>
      </>
    );
  }
}

CardButton.propTypes = {
  resource: PropTypes.object.isRequired,
};
